import { useFileDragDrop } from '@/components/FileDragDrop/hooks';
import { cx } from '@trinity/chat-components';
import { RateLimitingContext } from '@trinity/chat-components/containers/RateLimiting/Context.js';
import gridStyles from './style/Files.Table.Grid.module.css';
import listStyles from './style/Files.Table.module.css';

type DnDUploadContainerProps = {
  canUpload: boolean;
  onUpload?: (files: File[]) => unknown;
  children: React.ReactNode;
};

export const DnDUploadContainer = ({ children, onUpload, canUpload }: DnDUploadContainerProps) => {
  const { dragging, dropRef } = useFileDragDrop({
    disabled: false,
    onDrop: onUpload,
  });

  if (canUpload) {
    return (
      <div
        ref={dropRef}
        className={cx({
          [listStyles.dragging]: dragging,
          [gridStyles.dragging]: dragging,
        })}>
        {children}
      </div>
    );
  }

  return <>{children}</>;
};